import { render, staticRenderFns } from "./CommissionDistributionRuleSetForm.vue?vue&type=template&id=0399c740"
import script from "./CommissionDistributionRuleSetForm.vue?vue&type=script&lang=js"
export * from "./CommissionDistributionRuleSetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports